<template>
  <section>
    <h2 class="light">{{ $t("group.members.header") }}: <strong>{{ members.length }}</strong></h2>
    <a v-if="enabled" @click="showModal = true" class="button light">{{ $t("group.members.button.invite") }}</a>
    <h3 class="light" v-if="enabled"> {{ $t("plan.planAdmins.invitationsLeft") }}: <span class="error">{{ invitationsLeft }}</span></h3>
    <Modal v-if="showModal" v-bind:modalTitle="$t('group.members.modal.header')" @close="closeModal">
      <GroupInviteForm v-bind="{ groupId: groupId, invitationsLeft: this.invitationsLeft, clickLimit: this.invitationsLeft-1 }" />
    </Modal>
    <Loader v-if="!membersLoaded"/>
    <table v-if="membersLoaded" id="groups">
      <caption class="caption">Group members table</caption>
      <tr class="header">
        <th scope="col">{{ $t("group.members.table.name") }}</th>
        <th scope="col">{{ $t("group.members.table.email") }}</th>
        <th scope="col">{{ $t("group.members.table.role") }}</th>
        <th scope="col" v-if="enabled">{{ $t("group.members.table.actions") }}</th>
      </tr>
      <tr v-for="(member, index) in members" v-bind:key="index">
        <td>{{ member.givenName + ' ' + member.familyName }}</td>
        <td>{{ member.emailAddress }}</td>
        <td>
          <strong v-if="member.role === 'PlanOwner'">{{ $t("group.members.planAdmin") }}</strong>
          <groupEditForm
            v-else-if="enabled"
            v-bind:groupId="groupId"
            v-bind:appUserId="member.userId"
            v-bind:defaultRole="(member.role === 'Owner') ? 1 : 0"
          />
          <p v-else>{{ member.role }}</p>
        </td>
        <td v-if="enabled"><DeleteMember v-if="member.role !== 'PlanOwner'" v-bind:memberName="member.givenName + ' ' + member.familyName" v-bind:appUserId="member.userId" v-bind:groupId="groupId"/></td>
      </tr>
    </table>
  </section>
</template>

<script>
import Loader from '@/components/Loader.vue'
import Modal from '@/components/Modal.vue'
import DeleteMember from '@/components/group/DeleteMember.vue'
import GroupInviteForm from '@/components/group/MemberInviteForm.vue'
import GroupEditForm from '@/components/group/MemberEditForm.vue'

import { groupService } from '@/services/group.service'
import { planService } from '@/services/plan.service'

export default {
  props: ['groupId', 'planId', 'enabled'],
  name: 'Members',
  components: {
    Loader,
    Modal,
    DeleteMember,
    GroupInviteForm,
    GroupEditForm
  },
  data: function () {
    return {
      members: [],
      membersLoaded: false,
      showModal: false,
      currentPlanMembers: 0,
      maxPlanMembers: 0,
      invitationsLeft: 0
    }
  },
  created: function () {
    this.fetchMembers()
    this.calInvitationsLeft()
  },
  methods: {
    fetchMembers: function () {
      // Get members of the group
      groupService.getMembers(this.groupId).then(members => {
        this.members = members
        this.membersLoaded = true
      }).catch((err) => {
        console.error('Unable to get group members: ', err)
      })
    },
    calInvitationsLeft: function () {
      // Get admins for the plan
      planService.getCurrentPlanMembers(this.planId).then(plan => {
      this.currentPlanMembers = plan
      this.$forceUpdate()

        planService.getPlanByMember(this.planId).then(plan => {
          this.maxPlanMembers = plan.maxPlanMembers
          this.$forceUpdate()
          this.invitationsLeft = this.maxPlanMembers - this.currentPlanMembers
        })
      })
    },
    closeModal: function (event) {
      this.showModal = false
      this.$router.go(0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
section {
  margin-bottom: 60px;
  max-width: 75%;
}

h2 {
  color: $primary;
  font-weight: $regular;
  float: left;
  margin-right: 40px;
  margin-bottom: 20px;
}

h3 {
  color: $primary;
  font-weight: $regular;
  float: left;
  margin-right: 40px;
  margin-left: 10px;
  margin-top: 10px;
}

a.button.light {
  float: left;
  margin: 7px 0;
}

table {
  width: 100%;
  margin-top: 17px;
  border-collapse: collapse;
  .caption {
    display: none;
  }
}

tr.header {
  color: $text-light;
  background: $primary;
  th {
    text-align: left;
    border: none;
    padding: 7px 0 7px 28px;
  }
}

td {
  text-align: left;
  background: $surface-alpha;
  border-bottom: 2px solid $surface-beta;
  padding: 21px 0 21px 28px;

  .launch {
    background: url('../../assets/icons/launch.png') no-repeat left center;
    padding-left: 30px;
  }
}
</style>
